class PostMessenger {
  static send(message, data) {
    return new PostMessenger(data).send(message);
  }

  static productSelected(data) {
    return PostMessenger.send('catalog:product-selected', data);
  }

  constructor(data) {
    this.styleId = data.styleId;
    this.colorId = data.colorId;
    this.categoryPath = data.categoryPath;
    this.categoryTree = data.categoryTree;
    this.nextPath = data.nextPath;
  }

  send(message) {
    if (!message || !this.styleId || !this.colorId || !this.categoryPath) {
      console.error(
        'message, @styleId @colorId and @categoryPath are all required.'
      );
    }
    const payload = {
      event: message,
      styleId: this.styleId,
      colorId: this.colorId,
      categoryPath: this.categoryPath,
      acenstors: this.categoryTree
    };
    if (this.nextPath) {
      payload['nextPath'] = this.nextPath;
    }
    return window.parent.postMessage(
      payload,
      this.isProduction() ? 'https://www.customink.com' : '*'
    );
  }

  // private

  isProduction() {
    return location.host.match(/www\.customink\.com/);
  }
}

ProductCatalog.PostMessenger = PostMessenger;
